import { useCallback, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';

const isAllKeysHaveValue = (object) => Object.values(object).every((v) => !!v);

const useOnSearch = (callback) => {
  const router = useRouter();

  const {
    departureDate,
    returnDate,
    adults,
    originCode,
    children = '0',
    infants = '0',
    travelClass = 'economy',
  } = router.query;

  const params = useMemo(() => {
    const data = {
      originCode,
      departureDate,
      returnDate,
      adults,
      children,
      infants,
      travelClass,
    };

    if (!isAllKeysHaveValue(data)) {
      return undefined;
    }

    return data;
  }, [
    originCode,
    departureDate,
    returnDate,
    adults,
    children,
    infants,
    travelClass,
  ]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const enhancedCallback = useCallback(async () => {
    if (!params) {
      /*
       * When function been called but there is no params
       *
       * ExpectedHandler, unset state if no params
       *
       * Case:
       * Use related destination to navigate between destination page,
       * <DesignationPage /> re-rendered but not re-mounted
       * it recreates cb with new propertyIds but no params
       */
      await callback();
      return;
    }

    setLoading(true);
    setError();

    try {
      await callback(params);
    } catch (e) {
      setError(e);
    }

    setLoading(false);
  }, [params, callback]);

  useEffect(() => {
    enhancedCallback();
  }, [enhancedCallback]);

  return {
    params,
    loading,
    error,
  };
};

export default useOnSearch;
